import { createHashRouter, redirect } from 'react-router-dom';
import { HomePage } from 'src/modules/home/HomePage.tsx';
import { ErrorBoundary } from 'src/modules/common/components/ErrorBoundary/ErrorBoundary';
import { UserInputPage } from 'src/modules/user-input/UserInputPage.tsx';
import { ValvesPage } from 'src/modules/valves/ValvesPage.tsx';
import { ActuatorsPage } from 'src/modules/actuators/ActuatorsPage.tsx';
import { AccessoriesPage } from 'src/modules/accessories/AccessoriesPage.tsx';
import { BELIMO_HASH_PREFIX } from 'src/BELIMO_HASH_PREFIX.ts';
import { PrefetchValvesCheckout } from 'src/modules/checkout/PrefetchValvesCheckout.tsx';

export enum PATHS {
    Home = `${BELIMO_HASH_PREFIX}/`,
    UserInput = `${BELIMO_HASH_PREFIX}/input`,
    Valves = `${BELIMO_HASH_PREFIX}/valves`,
    ValvesFilter = `${BELIMO_HASH_PREFIX}/valves-filter`,
    Actuators = `${BELIMO_HASH_PREFIX}/actuators`,
    ActuatorsFilter = `${BELIMO_HASH_PREFIX}/actuators-filter`,
    Accessories = `${BELIMO_HASH_PREFIX}/accessories`,
    Checkout = `${BELIMO_HASH_PREFIX}/checkout`,
}

const errorElement = <ErrorBoundary/>;

export const router = () => createHashRouter([
    {
        path: '/',
        loader: () => redirect(PATHS.Home),
    },
    {
        path: PATHS.Home,
        element: <HomePage/>,
        errorElement,
    },
    {
        path: PATHS.UserInput,
        element: <UserInputPage/>,
        errorElement,
    },
    {
        path: `${PATHS.Valves}/:page`,
        element: <ValvesPage/>,
        errorElement,
    },
    {
        path: `${PATHS.Actuators}/:label/:page`,
        element: <ActuatorsPage/>,
        errorElement,
    },
    {
        path: `${PATHS.Accessories}/:valveLabel/:actuatorLabel/:page`,
        element: <AccessoriesPage/>,
        errorElement,
    },
    {
        path: `${PATHS.Checkout}/:valveLabel/:actuatorLabel/:page`,
        element: <PrefetchValvesCheckout/>,
        errorElement,
    },
    {
        path: '*',
        element: <HomePage/>,
        errorElement,
    },
]);
